JuiceProgram = window.JuiceProgram ?= {}
JuiceProgram.Model = require './models/juice_program'
JuiceProgram.View = require './views/juice_program'

JuiceProgram.init = ({buyButton}, done = -> ) ->
  return unless buyButton.JuiceProgramInfo?.isJuiceProgramEnabled
  juiceModel = new JuiceProgram.Model buyButton.JuiceProgramInfo
  juiceView = new JuiceProgram.View model: juiceModel

  $ =>
    juiceView.render()
    done()

module.exports = JuiceProgram



// WEBPACK FOOTER //
// ./modules/juice_program/frontend/juice_program.coffee